import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { BackTop, Layout } from 'antd';
import ErrorBoundary from './error/ErrorBoundary';
import RightHeader from '@/layouts/header/RightHeader';
import { CustomLayoutContext } from '@/layouts/provider';

const { Content, Header } = Layout;

function PrimaryLayout({ children }) {
  const { headerDisplay } = useContext(CustomLayoutContext);
  return (
    <Layout className="main-layout">
      {headerDisplay && (
        <Header className="primary-layout-header">
          <RightHeader />
        </Header>
      )}
      <Layout>
        <Content className="content-layout">
          <ErrorBoundary>{children}</ErrorBoundary>
          <BackTop />
        </Content>
      </Layout>
    </Layout>
  );
}

PrimaryLayout.propTypes = {
  children: PropTypes.element.isRequired,
};

export default PrimaryLayout;
